import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/chain/matic_24.svg.ts
import { svg } from "lit";
var matic24Svg = ({ width, height }) => svg`
<svg width="${width ?? 24}" height="${height ?? 24}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12.0015" r="12" fill="url(#paint0_linear_6718_21383)"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5522 6.08883C15.337 5.97039 15.0753 5.97039 14.8601 6.08883L11.6539 7.85352C11.4277 7.97801 11.2874 8.21421 11.2874 8.47057V9.61821L12.7124 10.4117V8.88591L15.2062 7.51337L17.6999 8.8859V11.5846L15.2062 12.9571L9.13973 9.61821C8.92454 9.49977 8.66288 9.49977 8.4477 9.61821L5.24148 11.3829C5.01528 11.5074 4.875 11.7436 4.875 11.9999V15.5293C4.875 15.7857 5.01528 16.0219 5.24148 16.1464L8.4477 17.9111C8.66288 18.0295 8.92454 18.0295 9.13973 17.9111L12.346 16.1464C12.5721 16.0219 12.7124 15.7857 12.7124 15.5293V14.3817L11.2874 13.5882V15.114L8.79371 16.4865L6.29999 15.114V12.4153L8.79371 11.0427L14.8601 14.3817C15.0753 14.5001 15.337 14.5001 15.5522 14.3817L18.7584 12.617C18.9846 12.4925 19.1249 12.2563 19.1249 11.9999V8.47057C19.1249 8.21421 18.9846 7.97801 18.7584 7.85352L15.5522 6.08883Z" fill="white"/>
  <defs>
    <linearGradient id="paint0_linear_6718_21383" x1="-4.38598" y1="1.97401" x2="20.3902" y2="17.1358" gradientUnits="userSpaceOnUse">
      <stop stop-color="#A229C5"/>
      <stop offset="1" stop-color="#7B3FE4"/>
    </linearGradient>
  </defs>
</svg>
`;
export {
  matic24Svg
};
//# sourceMappingURL=matic_24.svg-MR2PZC5O.js.map
